const isChrome =
  /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test( navigator.userAgent) || window.location.href.indexOf("sarv")>-1;
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const isIphone = /(iPhone|iPad)/i.test(navigator.userAgent) || window.location.href.indexOf("sarv")>-1;;
export { isChrome, isMobile, isSafari, isIphone };
module.export = {
  isChrome,
  isMobile,
  isSafari,
  isIphone,
};
